/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import ITemplateModel from 'apmui/master/Model';
import PageType from 'apmui/page/PageType';

enum SUBTYPE {
    LOGOUT = 'logout',
    ACCESS_NOT_FOUND = 'access_notfound',
    URL_FILTER_BLOCKED = 'urlfilter_blocked',
    REQUEST_BLOCKED = 'request_blocked',
    ACL_DENIED = 'my.acl',
    EPI_REMEDIATION = 'epi_remediation',
}

enum MESSAGE {
    MAIN = 'main',
    TEXT = 'text',
    RICHTEXT = 'richtext',
    NEWSESSION = 'newsession',
    HANGUP = 'hangup',
    BACK = 'goback',
    REFRESH = 'refresh',

    SESSION = 'session',

    APPLICATIONNAME = 'applicationname',
    APPLICATIONFAMILY = 'applicationfamily',
    SWGSESSION = 'swgsession',
    SWGCATEGORY = 'swgcategory',

    URI = 'uri',
    IF_PARAM_TEXT = 'if_param_text',
}

enum URI {
    HANGUP = '/vdesk/hangup.php3',
    REFRESH = 'javascript:history.go(0)',
    BACK = 'javascript:history.go(-1)',
}

/**
 * Configuration data specific to Logon Page agent
 */
interface IMessage {
    type: MESSAGE;
    text?: string;
    uri?: string;
    param: string;
    present?: boolean;
}

interface ILogoutModel extends ITemplateModel {
    /*
     * Page type tag
     */
    pageType: PageType.LOGOUT;

    /*
     * Logout config
     */
    [PageType.LOGOUT]: {
        /*
         * Subtype of the page
         */
        config: {
            errorcode: number;
            subtype: SUBTYPE;
        };
        /*
         * Messages on logout page are in array
         */
        messages: IMessage[];
        images: {
            image00: string;
            image01: string;
            image02: string;
            image03: string;
            image04: string;
            image05: string;
            image06: string;
            image07: string;
            image08: string;
            image09: string;
        };
    };
}

export { ILogoutModel as default, URI, MESSAGE, SUBTYPE };
